import React, { Component } from 'react';
import { connect } from 'react-redux';
import SellPaymentsPanelView from './SellPaymentsPanel.view';
import { put } from "redux-saga/effects";


export class SellPaymentsPanelContainer extends Component {

  constructor(props) {
    super(props);
    this.openSellPaymentsModal = this.openSellPaymentsModal.bind(this);
    this.togglePayment = this.togglePayment.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
    this.sendSellPayment = this.sendSellPayment.bind(this);
    this.setPaymentAsFraud = this.setPaymentAsFraud.bind(this);
    this.setAsFraud = this.setAsFraud.bind(this);

    this.state = {
      selectedPayments: [],
      sendingPayments: [],
    }
  }

  componentDidMount() {
    const { trade, filtersFormState } = this.props;
    this.onFilterChange({
      ...filtersFormState,
      data: {
        ...filtersFormState.data,
        type: trade && trade.type,
      },
    });
    this.getData(this.props);
  }

  getData(props) {
    const { dispatch, trade } = props;
    dispatch({
      type: 'FETCH_SELL_CHANNELS',
      payload: {
        tradeId: trade.tradeId,
      }
    });
  }

  togglePayment({ checked, _id }) {
    if (checked) {
      this.setState({
        selectedPayments: this.state.selectedPayments.concat(_id),
      });
    } else {
      this.setState({
        selectedPayments: this.state.selectedPayments.filter(item => item !== _id),
      });
    }
  }

  openSellPaymentsModal() {
    const { dispatch } = this.props;

    dispatch({
      type: 'TOGGLE_SELL_PAYMENTS_MODAL',
      payload: {
        active: true,
      },
    });
  }

  setAsFraud(channel) {
    const { dispatch, trade } = this.props;

    if (confirm('Are you sure you want to set this channel/payment as fraud?')) {
      dispatch({
        type: 'SET_SELL_CHANNEL_AS_FRAUD',
        payload: {
          tradeId: trade.tradeId,
          data: channel,
        },
      });
    }
  }

  setPaymentAsFraud(payment) {
    const { dispatch, trade, filtersFormState } = this.props;

    if (confirm('Are you sure you want to set this payment as fraud?')) {
      dispatch({
        type: 'SET_SELL_PAYMENT_AS_FRAUD',
        payload: {
          payment,
          filters: {
            type: trade.type,
            sort: filtersFormState.data.sort,
          }
        },
      });
    }
  }

  onFilterChange(filtersFormState){
    const { dispatch } = this.props;
    dispatch({
      type: 'SELL_PAYMENT_FILTERS_CHANGE',
      payload: {
        filtersFormState,
      }
    });
  }

  sendSellPayment(paymentId) {
    const { dispatch, trade, filtersFormState } = this.props;

    if (confirm('Are you sure you want to send this card to the customer. This action can not be reversed.')) {
      this.setState({
        sendingPayments: this.state.sendingPayments.concat(paymentId),
      });

      dispatch({
        type: 'SEND_SELL_PAYMENT',
        payload: {
          tradeId: trade.tradeId,
          paymentId,
          filters: {
            type: trade.type,
            sort: filtersFormState.data.sort,
          }
        }
      });
    }
  }

  render() {
    const { payments } = this.props;
    const availablePayments = payments && payments.filter(item => this.state.selectedPayments.indexOf(item._id) > -1);
    return (<SellPaymentsPanelView
      {...this.props}
      {...this.state}
      openSellPaymentsModal={this.openSellPaymentsModal}
      togglePayment={this.togglePayment}
      onFilterChange={this.onFilterChange}
      sendSellPayment={this.sendSellPayment}
      setAsFraud={this.setAsFraud}
      setPaymentAsFraud={this.setPaymentAsFraud}
      availablePayments={availablePayments}
    />);
  }

}

function mapStateToProps(state) {
  const { payments, sellPaymentsModalActive, filtersFormState, channels } = state.sellPaymentsPanel;
  return {
    payments,
    sellPaymentsModalActive,
    filtersFormState,
    channels,
  };
}

export default connect(mapStateToProps)(SellPaymentsPanelContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsPanel.container.js